const accountPreDomain = "account-pre";
const accountDomain = "account";
const TaskPreDomain = "task-pre";
const TaskDomain = "task";

export const getDomain = () => {
  if (
    location.hostname.includes("foxrenderfarm") ||
    location.hostname.includes("localhost")
  ) {
    return 1;
  }
  return 0;
};

export const getEnvironmentUrl = () => {
  const lastDomain = document.domain.split(".")[0];
  return lastDomain === TaskDomain ? TaskDomain : TaskPreDomain;
};
export const getDomainName = (level = 1) => {
  return document.domain.split(".").reverse()[level - 1];
};

export const getUserCenterRedirectDomain = () => {
  const DomainMap = new Map([
    [accountPreDomain, TaskPreDomain],
    [accountDomain, TaskDomain],
    [TaskPreDomain, accountPreDomain],
    [TaskDomain, accountDomain],
  ]);
  return `${DomainMap.get(getDomainName(3))}.${getDomainName(
    2
  )}.${getDomainName(1)}`;
};

export const isTaskDomain = () => {
  return [TaskDomain, TaskPreDomain].includes(getDomainName(3));
};

export const isUserCenterDomain = () => {
  return [accountDomain, accountPreDomain].includes(getDomainName(3));
};
